import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { BreakdownChartItem } from './breakdown-chart-item';
import { BreakdownChartSwitch } from './breakdown-chart-switch';
import type { BreakdownChartSeriesData } from '../../types';
interface BreakdownLegendProps {
  handleToggleSeries: (series: string) => void;
  series: BreakdownChartSeriesData[];
  onLegendItemHover: (legendName: string) => void;
  onLegendItemLeave: (legendName: string) => void;
  isChecked: boolean;
  handleChangeSwitch: () => void;
  showLegendValue?: boolean;
  showScrollAndToggle?: boolean;
}
function BreakdownLegend(t0) {
  const $ = _c(28);
  const {
    series,
    handleToggleSeries,
    onLegendItemHover,
    onLegendItemLeave,
    showLegendValue,
    showScrollAndToggle: t1,
    isChecked,
    handleChangeSwitch
  } = t0;
  const showScrollAndToggle = t1 === undefined ? false : t1;
  const t2 = showScrollAndToggle && "w-full flex-row flex-wrap items-center justify-center gap-x-2 gap-y-4";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("mx-auto mt-[22px] flex w-fit flex-col items-start justify-center gap-4", t2, "md:hidden");
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== handleToggleSeries || $[3] !== onLegendItemHover || $[4] !== onLegendItemLeave || $[5] !== series || $[6] !== showLegendValue) {
    let t5;
    if ($[8] !== handleToggleSeries || $[9] !== onLegendItemHover || $[10] !== onLegendItemLeave || $[11] !== showLegendValue) {
      t5 = element => {
        const value = element.data.reduce(_temp, 0);
        return <BreakdownChartItem element={element} key={element.name} handleToggleSeries={() => {
          handleToggleSeries(element.name);
        }} onLegendItemHover={() => {
          onLegendItemHover(element.name);
        }} onLegendItemLeave={() => {
          onLegendItemLeave(element.name);
        }} showLegendValue={showLegendValue} value={value} />;
      };
      $[8] = handleToggleSeries;
      $[9] = onLegendItemHover;
      $[10] = onLegendItemLeave;
      $[11] = showLegendValue;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = series.map(t5);
    $[2] = handleToggleSeries;
    $[3] = onLegendItemHover;
    $[4] = onLegendItemLeave;
    $[5] = series;
    $[6] = showLegendValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div data-slot="legend-mobile-container" className={t3}>{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== handleChangeSwitch || $[17] !== handleToggleSeries || $[18] !== isChecked || $[19] !== onLegendItemHover || $[20] !== onLegendItemLeave || $[21] !== series || $[22] !== showLegendValue || $[23] !== showScrollAndToggle) {
    t6 = showScrollAndToggle ? <div data-slot="legend-container" className={cn("bg-card hidden", "md:flex md:h-full md:w-[231px] md:min-w-[231px] md:flex-1 md:flex-col md:justify-center md:gap-2 md:rounded-xl md:p-2 md:pb-4 md:pl-4", "lg:w-[362px] lg:min-w-[362px]", "xl:w-[355px] xl:min-w-[355px]", "2xl:w-[392px] 2xl:min-w-[392px]")}><div data-slot="switch-container" className="hidden md:flex md:w-full md:flex-row md:justify-end"><BreakdownChartSwitch isChecked={isChecked} handleChangeSwitch={handleChangeSwitch} /></div><div data-slot="scroll-container" className="relative flex h-full flex-col items-center gap-1"><SimpleBar data-slot="simplebar-wrapper" className={cn("flex h-full w-full flex-col items-center justify-center", "[&_.simplebar-scrollbar::before]:ml-1 [&_.simplebar-scrollbar::before]:h-16 [&_.simplebar-scrollbar::before]:w-1 [&_.simplebar-scrollbar::before]:rounded-xl", "[&_.simplebar-scrollbar::before]:bg-muted-foreground", "md:h-[215px] md:max-h-[215px]", "lg:h-[235px] lg:max-h-[235px]", "xl:h-[300px] xl:max-h-[300px]", "2xl:h-[300px] 2xl:max-h-[300px]")}><div data-slot="series-container" className={cn("flex min-h-full flex-row flex-wrap content-start items-center justify-start gap-x-4 gap-y-4", "md:pr-3")}>{series.map(element_0 => {
              const value_0 = element_0.data.reduce(_temp2, 0);
              return <BreakdownChartItem element={element_0} key={element_0.name} handleToggleSeries={() => {
                handleToggleSeries(element_0.name);
              }} onLegendItemHover={() => {
                onLegendItemHover(element_0.name);
              }} onLegendItemLeave={() => {
                onLegendItemLeave(element_0.name);
              }} showLegendValue={showLegendValue} value={value_0} />;
            })}</div></SimpleBar></div></div> : <div data-slot="simple-container" className={cn("bg-accent hidden", "md:flex md:w-[231px] md:min-w-[231px] md:flex-1 md:flex-col md:items-center md:justify-center md:rounded-xl md:px-4", "lg:h-[288px]", "xl:h-[353px]", "2xl:h-[353px] 2xl:max-w-[392px]")}><div data-slot="simple-series-container" className={cn("flex flex-col items-start justify-center", series.length === 7 ? "gap-y-4" : "gap-y-6", "md:h-[268px]", "lg:h-[288px]", "xl:h-[353px]")}>{series.map(element_1 => {
          const value_1 = element_1.data.reduce(_temp3, 0);
          return <BreakdownChartItem element={element_1} key={element_1.name} handleToggleSeries={() => {
            handleToggleSeries(element_1.name);
          }} onLegendItemHover={() => {
            onLegendItemHover(element_1.name);
          }} onLegendItemLeave={() => {
            onLegendItemLeave(element_1.name);
          }} showLegendValue={showLegendValue} value={value_1} />;
        })}</div></div>;
    $[16] = handleChangeSwitch;
    $[17] = handleToggleSeries;
    $[18] = isChecked;
    $[19] = onLegendItemHover;
    $[20] = onLegendItemLeave;
    $[21] = series;
    $[22] = showLegendValue;
    $[23] = showScrollAndToggle;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}
function _temp3(prev_1, current_1) {
  return prev_1 + (current_1.value ?? 0);
}
function _temp2(prev_0, current_0) {
  return prev_0 + (current_0.value ?? 0);
}
function _temp(prev, current) {
  return prev + (current.value ?? 0);
}
export { BreakdownLegend };